import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ITopic } from "../../types/backend";
import { callFetchTopic } from "../../config/api";

interface IState {
  isFetching: boolean;
  meta: {
    current: any;
    pageSize: any;
    pages: any;
    total: any;
  };
  result: ITopic[];
}

// first, create thunk
export const fetchTopic = createAsyncThunk(
  "topic/fetchTopic",
  async ({ query }: { query: string }) => {
    const response = await callFetchTopic(query);
    return response;
  }
);

const initialState: IState = {
  isFetching: true,
  meta: {
    current: 1,
    pageSize: 10,
    pages: 0,
    total: 0,
  },
  result: [],
};

export const topicSlice = createSlice({
  name: "topic",
  initialState,
  reducers: {
    setActiveMenu: (state, action) => {},
  },

  extraReducers: (builder) => {
    builder.addCase(fetchTopic.pending, (state, action) => {
      state.isFetching = true;
    });
    builder.addCase(fetchTopic.rejected, (state, action) => {
      state.isFetching = false;
    });
    builder.addCase(fetchTopic.fulfilled, (state, action: any) => {
      if (action.payload && action.payload.data) {
        state.isFetching = false;
        state.meta = action.payload.data.meta;
        state.result = action.payload.data.result;
      }
    });
  },
});

export const { setActiveMenu } = topicSlice.actions;

export default topicSlice.reducer;
